import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import './AddRessource.css';
import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
 
  

} from "reactstrap"
import Select from "react-select"
import axios from 'axios'
import  { Redirect } from 'react-router-dom'
// import $ from "jquery";

import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js";

import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"

import url from "../../common/api"
import urlApiFile from "../../common/ApiFile"

const optionGroup = [
    {
      
      options: [
        { label: "PDF", value: "PDF" },
        { label: "MP4", value: "MP4" },
        { label: "JPEG", value: "JPEG" },
        { label: "MP3", value: "MP3" },
        { label: "EXCEL", value: "EXCEL" },
        
      ]
    },
    
  ]
  const optionLangue = [
    {
      
      options: [
        { label: "Francais", value: "Francais" },
        { label: "Anglais", value: "Anglais" },
        { label: "Wolof", value: "Wolof" }
      ]
    },
   
  ]
class ModifierRessource extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedGroup: null,
            selectedLangue:"Langue",
            format:[],
            langue:[],
            unite:[],
            irrigue:[],
            profile:[],
            motcle:[],
            type_ressource:[],
            thematique:[],
            idPrive:"prive",
            idThematique:"thematique",
            profile_id:[],

            profile_ids:[],

            motcle_ids:[],
            thematique_ids:[],
            langue_ids:[],
            unite_ids:[],
            systeme_irrigue_ids:[],
            ok:"",
            counter:0,
            public_id:0,
            pj_ids:[],
            image_ids:[],
            localisation_ids:[],
            localisation:[],
            file_counter:0,
            defaultDate:null,
            langues_attributes:[],
            unites_attributes:[],
            systeme_attributes:[],
            profiles_attributes:[],
            pjointes_attributes:[],
            localisation_attributes:[],
            imgs_attributes:[],
            mots_attributes:[],
            thematiques_attributes:[],
            defaultDate:new Date(),
            dateDebut:"",
            message:"Veuillez renseigner les champs obligatoires!!",
            taille:0,

            dateFin:"",
            acces:[],

            video:""

        }
        this.handleSelectGroup = this.handleSelectGroup.bind(this)
        this.handleSelectGroup2 = this.handleSelectGroup2.bind(this)

        // this.handleProfilePrive.bind(this);

        this.removeDuplicates.bind(this);
        this.handleChangeLocalisation.bind(this);
        this.handleChangeLangue.bind(this);
        this.handleChangeUnite.bind(this);
        this.handleChangeSysteme.bind(this);
        this.handleChangeMotCle.bind(this);
        this.handleChangeThematique.bind(this);
        this.handleDateDebut.bind(this);
        this.handleDateFin.bind(this);
        this.handleChangeProfile.bind(this);

    }
    handleCreer=()=>{
     
  

      var date=new Date();
      const NewDate= format(date,'dd/MM/yyyy');

      var data= {
        "nom": $("#nom").val(),
        "date_creation": NewDate,
        "derniere_date_maj": NewDate,
        "date_debut_publication": this.state.dateDebut,
        "date_fin_publication":this.state.dateFin,
        //"statut": $("#statut option:selected").text(),
        "statut":"ACTIF",
        "video": $("#video").val(),
        "image": "img",
        "description": $("#description").val(),
        "url": $("#url").val(),
        "utilisateur_id":JSON.parse(sessionStorage.getItem("authAshia")).id ,
        "le_format_id":$("#format_id option:selected").val(),
        "type_ressource_id":$("#type_ressource_id option:selected").val(),
        "ressource_profiles_attributes":this.state.profiles_attributes,
        "ressource_mot_cles_attributes":this.state.mots_attributes,
        "ressource_thematiques_attributes":this.state.thematiques_attributes,
        "ressource_pjointes_attributes":this.state.pjointes_attributes,
        "ressource_imgs_attributes":this.state.imgs_attributes,
        "ressource_langues_attributes":this.state.langues_attributes,
        "ressource_unite_administratives_attributes":this.state.unites_attributes,
        "ressource_systeme_irrigues_attributes":this.state.systeme_attributes,

        "ressource_pays_attributes":this.state.localisation_attributes

        
    }
      console.log("donnee transmises:",data)
  //   axios.post('http://localhost:3000/ressources',data)
  //   .then((response) => {
  //    console.log("enregistre:ressources")
  //  })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
        body: JSON.stringify(data)
    };
      
    

    fetch(url+'ressources', requestOptions)
    
       .then(response => response.json()
      )
      .then(data =>{console.log("enregitre avec succes vrai:",data)
        
        console.log("error type=====================>:",data)
        
          if(Object.keys(data).length<=2){
            $("#initial").css("display","block")
            $("#chargement").css("display","none")

            $("#echecSauv").css("display","block")

          }else{
          
            $("#chargement").css("display","none")
            this.handleRetour()
          }
       
     },
     (error) => {
      if (error) {
        $("#echecSauv").css("display","block")
        this.setState({message:"Une Erreur est survenue lors de la sauvegarde.Veuillez Reéssayer plutard!!!"})
        $("#initial").css("display","block")
        $("#chargement").css("display","none")
      }
     }  )

    }
  

    handleSelectGroup = selectedGroup => {
        this.setState({ selectedGroup })
      }

      handleSelectGroup2 = selectedLangue => {
        this.setState({ selectedLangue })
      }

  
      removeDuplicates=(data)=>{
        let unique = {};
        data.forEach(function(i) {
          if(!unique[i]) {
            unique[i] = true;
          }
        });
        return Object.keys(unique);
      }

      componentDidMount() {
         $("#chargement").css("display","none")
         $("#echecSauv").css("display","none")
         $("#profile").css("display","none")
         var date=new Date();
         const NewDate= format(date,'dd/MM/yyyy');
         this.setState({dateDebut:NewDate,dateFin:NewDate})


        fetch(url+"mot_cles")
        //fetch("http://localhost:3000/mot_cles")


        .then((response) => response.json() 
          )
        
        .then((data) => {
          data.map((element,idx) =>{
            this.setState({motcle:[...this.state.motcle,{value:element.id,label:element.libelle}]})
          })
          
         }
         
        );
        

        

        fetch(url+"pays")
        //fetch("http://localhost:3000/pays")

        .then((response) => response.json() 
          )
        
        .then((data) => {
          data.map((element,idx) =>{

            this.setState({localisation:[...this.state.localisation,{value:element.id,label:element.nom}]})
           
          })
          
         }
         
        );
    

        fetch(url+"le_formats")
        //fetch("http://localhost:3000/le_formats")

        .then((response) => response.json())
        .then((data) => {
          
          this.setState({format:data})
         }
         
        );

        fetch(url+"thematiques")
        //fetch("http://localhost:3000/thematiques")

        .then((response) => response.json())
        .then((data) => {
          data.map((element,idx) =>{
            this.setState({thematique:[...this.state.thematique,{value:element.id,label:element.libelle}]})
          })
         
         
         }
         
        );

        fetch(url+"profiles")
        .then((response) => response.json())
        .then((data) => {
          try{
           this.setState({public_id:data.filter(x => x.libelle === "Public")[0].id})
           console.log("data",data.filter(x => x.libelle === "Public"))
          }catch(error){
     
          }
     
          try{
           data.filter(x => x.libelle != "Public").map((element,idx) =>{
             this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
           })
     
         }catch(error){
           
         }
         
      
     
         // $("#"+this.state.idPrive+data[0].id).prop('checked',true)
       
         }
         
        );

       fetch(url+"unite_administratives")

       //fetch("http://localhost:3000/unite_administratives")

        .then((response) => response.json())
        .then((data) => {
          data.map((element,idx) =>{
            this.setState({unite:[...this.state.unite,{value:element.id,label:element.libelle}]})
          })
          
          
         }
         
        );

        fetch(url+"type_ressources")
        //fetch("http://localhost:3000/type_ressources")

        .then((response) => response.json())
        .then((data) => {
    
          
          this.setState({type_ressource:data})
         }
         
        );

        fetch(url+"type_systeme_irrigues")
        //fetch("http://localhost:3000/type_systeme_irrigues")

        .then((response) => response.json())
        .then((data) => {
          data.map((element,idx) =>{
            this.setState({irrigue:[...this.state.irrigue,{value:element.id,label:element.libelle}]})
          })
          
          
         }
         
        );

        fetch(url+"langues")
        //fetch("http://localhost:3000/langues")

        .then((response) => response.json())
        .then((data) => {
    
          data.map((element,idx) =>{
            this.setState({langue:[...this.state.langue,{value:element.id,label:element.nom}]})
          })
          
         }
         
        );
    

      }
// handleSaveRessource=()=>{

// }

  handleRetour=()=>{
    this.setState({ok: <Redirect to='/accueil'  />});
  }
  handleAnnuler=()=>{
    this.setState({ok: <Redirect to='/accueil'  />});
  }

  handleSendFile = ()=> {
    $("#initial").css("display","none")
    $("#chargement").css("display","block")

    var imageList=document.getElementById("image").files
    var pjList=document.getElementById("pieceJointe").files

    // if(!$(".prive").get(0).checked && this.state.public_id !=0){
    //   this.setState({profile_id:[...this.state.profile_id,this.state.public_id]})
    // }

    console.log("file upload===>",pjList,"--",imageList)


    this.setState({file_counter:parseInt(imageList.length)+parseInt(pjList.length)})

    
  
    
 
  if(imageList.length==0 && pjList.length==0){
    this.handleCreer()
  }
  else{

    for(var i=0;i<pjList.length;i++){
    const formData = new FormData(); 
     
    // Update the formData object 
    formData.append( 
      "avatar", 
      pjList[i] 
     
    ); 
    const requestOptions = {
      method: 'POST',
      body: formData
  };

    fetch("http://sis.ashia.sn/file/fileupload.php", requestOptions)
    .then((response) => response.json())
    .then(response =>{console.log("ok,",response)
    this.sendPjointe({"file":response.name,"taille":response.size},url+"pjointes",1)

   } ,
   (error) => {
    if (error) {
      $("#echecSauv").css("display","block")
      this.setState({message:"Echec Chargement du Fichier!!!"})
      $("#initial").css("display","block")
      $("#chargement").css("display","none")
    }
   })
  }; 
  


  for(var i=0;i<imageList.length;i++){
    const formData = new FormData(); 
     
    // Update the formData object 
    formData.append( 
      "avatar", 
      imageList[i] 
     
    ); 
    const requestOptions = {
      method: 'POST',
      mode: 'cors',
      headers: {'Access-Control-Allow-Origin':'*' },
      body: formData
    };

    fetch("http://sis.ashia.sn/file/fileupload.php", requestOptions)
    .then((response) => response.json()
    
    )
    .then(response =>{console.log("ok,",response)
     this.sendPjointe({"file":response.name,"taille":response.size},url+"images",0)

   },
   (error) => {
    if (error) {
      $("#echecSauv").css("display","block")
      this.setState({message:"Echec Chargement du Fichier!!!"})
      $("#initial").css("display","block")
      $("#chargement").css("display","none")
    }
   } )
  }; 
}
  }
   sendPjointe=(data,url,status)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
      body: JSON.stringify(data)
  };
  fetch(url, requestOptions)
  .then((response) => response.json())
  .then(response =>{console.log("file send,",response)
  this.setState({file_counter:parseInt(this.state.file_counter)-1})
   if(status==0){

     this.setState({imgs_attributes:[...this.state.imgs_attributes,{"image_id":response.id}]})
   }
   else{
    this.setState({pjointes_attributes:[...this.state.pjointes_attributes,{"pjointe_id":response.id}]})
   }
   
   if(this.state.file_counter==0){
    this.handleCreer()
   }

 } )
      
   }

  handleChangeLocalisation = (e) => {

    this.setState({localisation_attributes:[]})
    try{
    e.map((element,idx) =>{
      this.setState({localisation_attributes:[...this.state.localisation_attributes,{"pay_id":element.value}]})
      console.log("esai",e)
    })
  } catch(e){

  }
  }

  handleChangeLangue = (e) => {
    this.setState({langues_attributes:[]})
    try{
        e.map((element,idx) =>{
          this.setState({langues_attributes:[...this.state.langues_attributes,{"langue_id":element.value}]})
        })
      }catch(error){

      }   
  }
  handleChangeThematique = (e) => {
    this.setState({thematiques_attributes:[]})
    try{
      e.map((element,idx) =>{
        this.setState({thematiques_attributes:[...this.state.thematiques_attributes,{"thematique_id":element.value}]})
      })
    }catch(error){

    }
   
  }
  handleChangeUnite = (e) => {
    this.setState({unites_attributes:[]})
    try{
      e.map((element,idx) =>{
        this.setState({unites_attributes:[...this.state.unites_attributes,{"unite_administrative_id":element.value}]})
      })
    }catch(error){
      
    }
   
  }
  handleChangeSysteme = (e) => {
    
    this.setState({systeme_attributes:[]})
    try{
      e.map((element,idx) =>{
        this.setState({systeme_attributes:[...this.state.systeme_attributes,{"type_systeme_irrigue_id":element.value}]})
      })
    }catch(error){
      
    }
    
  }

  handleChangeMotCle = (e) => {
    this.setState({mots_attributes:[]})
    try{
      e.map((element,idx) =>{
        this.setState({mots_attributes:[...this.state.mots_attributes,{"mot_cle_id":element.value}]})
        })
    }catch(error){
      
    }
   
  }

  handleChangeAcces = () => {
    console.log("le select",$("#acces option:selected").val())
   if($("#acces option:selected").val()=="Privée"){
      $("#profile").css("display","block")
   }else{
    $("#profile").css("display","none")
    this.setState({profiles_attributes:[{"profile_id":this.state.public_id}]})
   }
  }

 handleChangeProfile = (e) => {
  var data=[]
  this.setState({profiles_attributes:[]})
  console.log("===>>",e)
  try{
    e.map((element,idx) =>{
      this.setState({profiles_attributes:[...this.state.profiles_attributes.filter(x => x.profile_id != this.state.public_id),{"profile_id":element.value}]})
      console.log("===>>profile",element)
    })

  }catch(e){

  }


}
 



  handleDateDebut= (date)=> {
    const NewDate= format(date[0],'dd/MM/yyyy');
    this.setState({dateDebut:NewDate})
  }
  handleDateFin= (date)=> {
    const NewDate= format(date[0],'dd/MM/yyyy');
    this.setState({dateFin:NewDate})
  }

  handleErrorFormat=(e)=>{
    if(e.target.value!=0){
      $("#valideSate").css("display","none")
      $("#format_id").removeClass("is-invalid")
      $("#echecSauv").css("display","none")
    }else{
      $("#valideSate").css("display","block")
      $("#format_id").addClass("is-invalid")
    }
  }

  handleErrorRessouce=(e)=>{
  
    if(e.target.value!=0){
      $("#valideRessource").css("display","none")
      $("#type_ressource_id").removeClass("is-invalid")
      $("#echecSauv").css("display","none")
    }else{
      $("#valideRessource").css("display","block")
      $("#type_ressource_id").addClass("is-invalid")
    }
  }

 render() {
    const { pick } = this.state
    const { selectedGroup } = this.state
    const { selectedLangue } = this.state
    const animatedComponents = makeAnimated();

  return (
          <React.Fragment>
            <div className="page-content"> {this.state.ok}
            <MetaTags>
                <title>Modifier la ressource</title>
            </MetaTags>
            <Container fluid={true}>
                <Row>
                  <Col md="8">
                      <div className="page-title-box d-flex align-items-center justify-content-between">
                      <h4 className="mb-0 font-size-18">Modifier la ressource</h4>
                      
                      </div>
                  </Col>
                </Row>
     
                <hr/>

                <Card>
                  <CardBody>
                  <Row> 
                    <Col md="8">
                      <label>Titre de la ressource</label>
                      <Input
                            className="form-control"
                            type="text"
                            id="nom"
                            placeholder="Titre de la ressource"
                        />
                    </Col>

                    <Col md="4">
                      <label>Format</label> 
                      <select onChange={this.handleErrorFormat} className="form-select is-invalid" aria-label="Default select example" id="format_id">
                        <option value="0" selected>Choisir le format</option>
                        {
                          this.state.format.map((element,idx) =>(
                            <option value={element.id}>{element.code}</option>
                          ))
                        }
                      </select>
                      <div id="valideState" class="invalid-feedback">
                        Svp veuillez Choisir le format.
                      </div>
                    </Col>

                    {/* <Col md="2">
                      <label>Statut</label>
                      <select className="form-select" aria-label="Default select example" id="statut">
                        <option selected>Choisir le statut</option>
                        <option value="1">ACTIF</option>
                        <option value="2">INACTIF</option>
                      </select>
                    </Col> */}
                  </Row>
                  
                  <Row className="mt-4"> 
                    <Col md="12" > 
                      <label>Description</label> 
                      <textarea  className="form-control" id="description" placeholder="Description" />
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="6">

                      <label>Localisation(s)</label>

                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                       onChange={this.handleChangeLocalisation}
                        options={this.state.localisation}
                        placeholder="Choisir la/les localisation(s)"
                      />
                    </Col>  
                    <Col md="6">

                      <label>Langue(s)</label>

                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeLangue}
                        options={this.state.langue}
                        placeholder="Choisir la/les langue(s)"
                      />
                    </Col>
                  </Row>


                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Unité(s) administrative</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeUnite}
                        options={this.state.unite}
                        placeholder="Choisir l'unité administrative"
                      />
                    </Col>  
                    <Col md="6">
                      <label>Type(s) de système(s) d'irrigation</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeSysteme}
                        options={this.state.irrigue}
                        placeholder="Choisir le/les type(s) de système d'irrigation"
                      />
                    </Col>
                  </Row>


                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Thématique(s)</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeThematique}
                        options={this.state.thematique}
                        placeholder="Choisir la/les thématique(s)"
                      />
                    </Col>  
                    <Col md="6">
                      <label>Mot(s) clé</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeMotCle}
                        options={this.state.motcle}
                        placeholder="Choisir le/les mot(s) clé"
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4"> 

                      <Col md="4">
                        <label>Type de Ressource</label>

                        <select onClick={this.handleErrorRessouce} className="form-select is-invalid" aria-label="Default select example" id="type_ressource_id">
                        <option value="0" selected>Choisir le type de ressource</option>
                        {
                          this.state.type_ressource.map((element,idx) =>(
                            <option value={element.id}>{element.libelle}</option>
                          ))
                        }
                      </select>
                      <div id="valideRessource" class="invalid-feedback">
                        Svp veuillez Choisir le type de ressource.
                      </div>
                      </Col>

                      <Col md="4">
                        <label>Date de début de publication</label>
                        <div className="docs-datepicker">
                          <InputGroup>
                            <Flatpickr
                              value={this.state.defaultDate}
                              className="form-control d-block"
                              placeholder="Date de début de publication"
                              options={{
                                locale:French,
                                altInput: true,
                                // altFormat: "F j, Y",
                                altFormat: "d/M/Y"
                              }}
                              onChange={this.handleDateDebut}
                            />
                            <div className="input-group-append">
                              <button
                                type="button"
                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                disabled
                              >
                                <i
                                  className="fa fa-calendar"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </InputGroup>
                          <div className="docs-datepicker-container" />
                        </div>
                      </Col>

                      <Col md="4">
                        <label>Date de fin de publication</label>
                        <div className="docs-datepicker">
                          <InputGroup>
                            <Flatpickr
                              value={this.state.defaultDate}
                              className="form-control d-block"
                              placeholder="Date de fin de publication"
                              options={{
                                locale:French,
                                altInput: true,
                                altFormat: "d/M/Y",
                                //dateFormat: "dd/MM/yyyy"
                              }}
                              onChange={this.handleDateFin}
                            />
                            <div className="input-group-append">
                              <button
                                type="button"
                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                disabled
                              >
                                <i
                                  className="fa fa-calendar"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </InputGroup>
                          <div className="docs-datepicker-container" />
                        </div>
                      </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="12"> 
                      <label>Url</label>
                      <div className="input-group">
                        <Input
                          type="text"
                          className="form-control"
                          id="url"
                          placeholder="URL"
                        />
                        <div className="input-group-prepend  d-inline-block">
                          <span
                            className="input-group-text h-20"
                            id="validationTooltipUsernamePrepend"
                          >
                            <i className="bx bx-link"></i>
                          </span>
                        </div>
                      </div> 
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="4">
                      <label>Video</label>
                      <div className="input-group">
                        <Input
                          className="form-control"
                          type="text"
                          placeholder="Vidéo"
                          id="video"
                        />
                        <div className="input-group-prepend  d-inline-block">
                          <span
                            className="input-group-text h-20"
                            id="validationTooltipUsernamePrepend"
                          >
                            <i className="bx bx-link"></i>
                          </span>
                        </div>
                      </div>
                    </Col>

                    <Col md="4"> 

                      <label>Image(s)</label>

                       <Input
                            className="form-control"
                            type="file"
                            multiple 
                            placeholder="Pièce jointe"
                            id="image"
                        />
                    </Col>

                    <Col md="4"> 

                      <label> Pièce(s) jointe</label>

                      <Input
                            className="form-control"
                            type="file"
                            multiple 
                            placeholder="Pièce jointe"
                            id="pieceJointe"
                      />
                    </Col>
                  </Row>  

                  </CardBody>
                </Card>

                <hr></hr>

                <Row className="mt-4"> 
                    <Col md="6">
                      <label>Accès</label>
                      <select className="form-select" onClick={this.handleChangeAcces} aria-label="Default select example" id="acces">
                        <option selected>Choisir le type d'accès</option>
                        <option value="Public">Public</option>
                        <option value="Privée">Privée</option>
                      </select>
                    </Col>  
                    <Col md="6" >
                      <div id="profile">
                      <label>Profile(s)</label>
                      <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          options={this.state.profile}
                          placeholder="Choisir le/les profils(s)"
                          onChange={this.handleChangeProfile} 
                          aria-label="Default select example" 
                          id="profile_id"
                        />
                    
                      </div>
                    </Col>
                  </Row>
                 <hr></hr>

                <Row className="mb-4">
                    
                    <h5>Image(s)</h5>
                    {/* {
                        (this.state.image.length!=0)?
                        (
                        (this.state.image.map(
                            (element,idx)=>(
                                <Col md="4">
                                <Card>
                                    <CardHeader> 
                                        <a> <i className="bx bxs-trash bx-sm text-primary " /> </a>
                                    </CardHeader>

                                    <img className="card-img-top" src={element} alt="Image"/>

                                    <CardFooter>
                                        <small className="text-muted">{element.file}</small>
                                    </CardFooter>
                                </Card>
                            </Col>
                            )
                        ))
                        ):(<span>Aucune image</span>)
                    } */}
                </Row>

                <Row className="mt-4 mb-4">
                    <Card>
                        <CardBody>
                            <CardTitle className="mb-4 h4">Pièce(s) jointe</CardTitle>
                            <div className="text-center">
                                <div className="mb-4">
                                    <i className="bx bx-file text-primary display-5" style={{ lineHeight : '1'}}/>
                                </div>
                            </div>
                            <div className="table-responsive mt-4">
                            <table className="table align-middle table-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: "30%" }}>

                                            Taille
                                        </th>
                                        <th style={{ width: "30%" }}>

                                            Nom
                                        </th>
                                        <th style={{ width: "25%" }}>
                                            Type
                                        </th>
                                        <th>
                                            Action
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {/* {
                                        (this.state.pjointe.length!=0)?
                                        (
                                           ( 
                                             this.state.pjointe.map(
                                                (element,idx)=>(
                                                    <tr>
                                                    <td style={{ width: "30%" }}>

                                                        <p className="mb-0">{element.taille}</p>
                                                    </td>
                                                    <td style={{ width: "30%" }}>

                                                   <p className="mb-0">{element.nom}</p>
                                                    </td>
                                                    <td style={{ width: "25%" }}>
                                                        <h5 className="mb-0">{element.type}</h5>
                                                    </td>
                                                    <td>
                                                        <a href={element.file} download > <i className="bx bxs-download bx-sm text-primary " /> </a>
                                                        <a> <i className="bx bxs-trash bx-sm text-primary " /> </a>
                                                    </td>
                                                </tr>
                                                )
                                             )  
                                           )
                                        ):null
                                    } */}
                                </tbody>
                            </table>
                            </div>
                        </CardBody>
                    </Card>
                </Row>


                <Row className="justify-content-start mt-5 mb-5">
                      <Col md="4">

                     

                      </Col>
                      <Col md="3">
                        <Button id="initial" color="info" className="b-lg" onClick={this.handleSendFile}>
                          Modifier 
                        </Button>
                        <Button id="chargement" color="info" className="b-lg" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                          Envoi...
                        </Button>
                      </Col>
                      <Col md="2">
                        <Button  color="secondary" onClick={this.handleAnnuler} className="b-lg">
                          Annuler
                        </Button>
                      </Col>
                     
                </Row>
                <Row className="justify-content-start mt-5 mb-5">
                      <Col md="3"></Col>
                      <Col md="6">
                      <div style={{textAlign:"center"}}>
                        <div id="echecSauv" className="alert alert-danger mt-2" role="alert">
                            {this.state.message}
                        </div>
                      </div>
                      </Col>
                      <Col md="3"></Col>

                </Row>        
               
                </Container>
                </div>
             
          </React.Fragment>
        )}

  }
  export default ModifierRessource